/* 客服 widget 包装方法 */
import i18n from '@ms/lang/i18n'
import chatBall from './ball.js'
import { useChatBall } from './useChatBall.js'
import { tryTellAppChatStats } from 'wap/hybrid'
import { isApp } from 'wap/hybrid/device.js'
import './chat.css'

const chat = {
  // 是否已挂载第三方 sdk
  ready: false,
  visibleBall: true,

  // 挂载 sdk
  setup() {
    return new Promise((resolve) => {
      if (window.zE) return resolve()
      let script = document.getElementById('ze-snippet')
      if (!script) {
        script = document.createElement('script')
        script.id = 'ze-snippet'
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${i18n.t('ZENDESK_KEY')}`
        document.querySelector('body').appendChild(script)
      }
      script.addEventListener('load', resolve)
    })
  },

  async init({ visibleBall = true, zIndex = 999 } = {}) {
    if (isApp() && !/\/about\/contact-us/.test(location.pathname)) {
      return console.warn('not support chat ball')
    }
    this.visibleBall = visibleBall
    if (!this.ready) {
      await this.setup()
      this.ready = true
      window.zESettings = {
        webWidget: {
          zIndex,
          offset: {
            // desktop 偏移樣式
            horizontal: '30px',
            vertical: '100px'
          },
          chat: {
            departments: {
              // 隐藏 departments 选项, 默认选择当前国家客服团队
              enabled: []
              // select: `${i18n.t('COUNTRY_NAME')} Customer Service Team`
            }
          }
        }
      }
      // set language
      if (!window.zE) return
      window.zE('webWidget', 'setLocale', 'en-US')
      this.prefill()
      window.zE('webWidget:on', 'userEvent', (event) => {
        console.log('userEvent:', event.action)
        switch (event.action) {
          case 'Web Widget Minimised':
            this.onChatClose()
            break

          default:
            break
        }
      })

      window.zE('webWidget:on', 'close', () => this.onChatClose)
      window.zE('webWidget:on', 'open', () => this.onChatOpen())
      window.zE('webWidget:on', 'chat:start', () => this.onChatStart())
      window.zE('webWidget:on', 'chat:end', this.onChatEnd)
      window.zE('webWidget:on', 'chat:unreadMessages', this.onUnreadMessages)

      window.zE('webWidget:on', 'chat:connected', () => {
        console.log('successfully connected to Zendesk Chat!')

        const isChatting = this.isChatting()
        if (visibleBall) {
          if (this.isChatting()) {
            chatBall.show()
          }
        }

        if (isChatting) {
          tryTellAppChatStats(1)
        }

        const cachedNewMessages = parseInt(sessionStorage.getItem('CHAT_NEW_MESSAGES_NUMS'))
        if (cachedNewMessages > 0) {
          useChatBall().updateNewMessages(cachedNewMessages)
          console.log('cached new messages num: ', cachedNewMessages)
        }
      })
    }

    return this
  },

  // 预填用户信息
  prefill() {
    window.zE('webWidget', 'prefill', {
      phone: {
        value: window.loginStatus ? localStorage.getItem('m_sport_user_phone') : ''
      }
    })
  },

  // 打开对话框
  async open() {
    await chat.init({ visibleBall: this.visibleBall })
    window.zE && window.zE('webWidget', 'open')
  },

  // 关闭对话框
  close() {
    window.zE && window.zE('webWidget', 'close')
    useChatBall().toggleVisible(false)
    return this
  },

  // 结束对话
  end() {
    window.zE && window.zE('webWidget', 'chat:end')
    return this
  },

  isChatting() {
    return window.zE && window.zE('webWidget:get', 'chat:isChatting')
  },
  // 客服系统：1开始对话2结束对话3新消息4最小化，startChat,endChat,newMessage,minimize

  onChatStart() {
    console.log('successfully started a Zendesk Chat!')
    tryTellAppChatStats(1)
  },

  onChatEnd() {
    console.log('successfully ended a Zendesk Chat session!')
    tryTellAppChatStats(2)
    chatBall.hide()
  },

  onUnreadMessages(number) {
    console.log(`It seems you have ${number} unread messages!`)
    useChatBall().updateNewMessages(number)
    tryTellAppChatStats(3, number)
  },

  // 关闭对话框
  onChatClose() {
    console.log('chat close')
    this.onClose && this.onClose()
    if (this.visibleBall && this.isChatting()) {
      chatBall.show()
    }
    tryTellAppChatStats(4)
  },

  // 打开对话框事件
  onChatOpen() {
    console.log('chat open')
    this.onOpen && this.onOpen()
    useChatBall().updateNewMessages(0)
    tryTellAppChatStats(3, 0)
  }
}

export default chat
